export var DriveFileType = /*#__PURE__*/function (DriveFileType) {
  DriveFileType["CLOUD"] = "CLOUD";
  DriveFileType["ATTACHMENT"] = "ATTACHMENT";
  DriveFileType["LOCAL_ATTACHMENT"] = "LOCAL_ATTACHMENT";
  return DriveFileType;
}({});

/**
 * Drive 文件
 */

/** 安全打击状态 */
export var AuditStatus = /*#__PURE__*/function (AuditStatus) {
  AuditStatus[AuditStatus["REGULAR"] = 0] = "REGULAR";
  AuditStatus[AuditStatus["ILLEGAL"] = 1] = "ILLEGAL";
  AuditStatus[AuditStatus["PASS"] = 2] = "PASS";
  AuditStatus[AuditStatus["AUDITING"] = 3] = "AUDITING";
  return AuditStatus;
}({});

/**
 * Drive 本地文件列表项
 */

/** 文档权限. 表示文档自身开放哪种权限. */
export var DocPolicy = /*#__PURE__*/function (DocPolicy) {
  DocPolicy[DocPolicy["Private"] = 0] = "Private";
  DocPolicy[DocPolicy["Designated"] = 1] = "Designated";
  DocPolicy[DocPolicy["EveryoneReadable"] = 2] = "EveryoneReadable";
  DocPolicy[DocPolicy["EveryoneEditable"] = 3] = "EveryoneEditable";
  return DocPolicy;
}({});

/** 文档来源. */
export var DocSource = /*#__PURE__*/function (DocSource) {
  DocSource[DocSource["Personal"] = 0] = "Personal";
  DocSource[DocSource["Enterprise"] = 1] = "Enterprise";
  DocSource[DocSource["External"] = 2] = "External";
  return DocSource;
}({});

/** 文档状态. */
export var DocStatus = /*#__PURE__*/function (DocStatus) {
  DocStatus[DocStatus["Normal"] = 0] = "Normal";
  DocStatus[DocStatus["Deleted"] = 1] = "Deleted";
  DocStatus[DocStatus["MovedToTrash"] = 2] = "MovedToTrash";
  DocStatus[DocStatus["Hidden"] = 3] = "Hidden";
  DocStatus[DocStatus["Transferred"] = 4] = "Transferred";
  DocStatus[DocStatus["Importing"] = 5] = "Importing";
  DocStatus[DocStatus["Auditing"] = 6] = "Auditing";
  DocStatus[DocStatus["Forbidden"] = 7] = "Forbidden";
  DocStatus[DocStatus["ImportFailed"] = 8] = "ImportFailed";
  DocStatus[DocStatus["Copying"] = 9] = "Copying";
  DocStatus[DocStatus["CopyFiled"] = 10] = "CopyFiled";
  DocStatus[DocStatus["Preparing"] = 11] = "Preparing";
  DocStatus[DocStatus["HiddenUntilModify"] = 12] = "HiddenUntilModify";
  DocStatus[DocStatus["Uploading"] = 13] = "Uploading";
  return DocStatus;
}({});

/** 文档类型描述. */
export var DocTypeDesc = /*#__PURE__*/function (DocTypeDesc) {
  DocTypeDesc["Doc"] = "doc";
  DocTypeDesc["Sheet"] = "sheet";
  DocTypeDesc["Form"] = "form";
  DocTypeDesc["Folder"] = "folder";
  DocTypeDesc["Slide"] = "slide";
  DocTypeDesc["Note"] = "note";
  DocTypeDesc["PDF"] = "pdf";
  DocTypeDesc["MiniProgram"] = "miniProgram";
  DocTypeDesc["Unknown"] = "unknown";
  DocTypeDesc["RelationGraph"] = "relationGraph";
  DocTypeDesc["MindMap"] = "mind_map";
  DocTypeDesc["FlowChart"] = "flow_chart";
  DocTypeDesc["File"] = "file";
  DocTypeDesc["DriveFile"] = "drive";
  DocTypeDesc["SogouSpeech"] = "rec";
  DocTypeDesc["Addon"] = "addon";
  return DocTypeDesc;
}({});

/** 租户. */
export var Tenant = /*#__PURE__*/function (Tenant) {
  Tenant["None"] = "";
  Tenant["WeCom"] = "wecom";
  return Tenant;
}({});

/** 认证信息. */

/** 个性化信息. */
/** 认证类型. */
var OfficialAuthType = /*#__PURE__*/function (OfficialAuthType) {
  OfficialAuthType[OfficialAuthType["None"] = 0] = "None";
  OfficialAuthType[OfficialAuthType["Enterprise"] = 1] = "Enterprise";
  OfficialAuthType[OfficialAuthType["EnterpriseMedia"] = 2] = "EnterpriseMedia";
  OfficialAuthType[OfficialAuthType["Government"] = 3] = "Government";
  OfficialAuthType[OfficialAuthType["NonProfitOrganization"] = 4] = "NonProfitOrganization";
  OfficialAuthType[OfficialAuthType["PrivateNonEnterprise"] = 5] = "PrivateNonEnterprise";
  OfficialAuthType[OfficialAuthType["ProfitOrganization"] = 6] = "ProfitOrganization";
  OfficialAuthType[OfficialAuthType["SocialGroup"] = 8] = "SocialGroup";
  OfficialAuthType[OfficialAuthType["PublicInstitutionMedia"] = 9] = "PublicInstitutionMedia";
  OfficialAuthType[OfficialAuthType["PublicInstitution"] = 11] = "PublicInstitution";
  OfficialAuthType[OfficialAuthType["IndividualCompany"] = 12] = "IndividualCompany";
  OfficialAuthType[OfficialAuthType["OverseaCompany"] = 13] = "OverseaCompany";
  return OfficialAuthType;
}(OfficialAuthType || {});
/** 个性化背景. */
/** 个性化标题颜色. */
/** 微盘信息. */
/** 预览信息 */
/**
 * Privilege
 * 当前用户对文件的权限
 */
export var DRIVE_FILE_KIND = 'drive#file';
export function isDriveFile(node) {
  return node.kind === DRIVE_FILE_KIND && !node.isLocal;
}
export function isLocalDriveFile(node) {
  return node.kind === DRIVE_FILE_KIND && node.isLocal;
}
export var DEFAULT_DOMAIN_ID = '300000000';
export var DEFAULT_CREATOR_DOMAIN = '300000000';
//# sourceMappingURL=drive-file.js.map